export enum StickyTabsOurPartners {
    INNOVA = 'innova',
    EGGER = 'egger',
    BLUM = 'blum',
    KESSEBOHMER = 'kessebohmer',
    DUROPAL = 'duropal'
};
